import { Article } from "../../../../shared/types/index.ts"
import { Calendar, ExternalLink, Share2, X } from "lucide-react"
import '../../global.css'
import { Link } from "react-router-dom";
import ImageAlbum from "../shared/imageAlbum.tsx";
import { ArticleTypeLabels } from '../../../../shared/types/index.ts';
import { articleImageUrls } from '../../utils/articleImageUrl';

type ArticleModalProps = {
    article: Article,
    setSelectedArticle: (article: Article | null) => void;
}

export default function ArticleModal({article, setSelectedArticle} : ArticleModalProps) {
    const date = new Date(article.createdAt);
    const imageUrls = articleImageUrls(article.images.map(i => i.url));

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[2000] flex items-center justify-center p-4">
            <div className="relative bg-white rounded-xl max-w-[90vw] h-[90vh] w-[64rem] shadow-xl overflow-hidden font-sans">
                <div 
                    className="absolute right-6 top-4 rounded-full z-[5000] flex size-12 bg-gray-200/80 backdrop-blur-sm items-center justify-center cursor-pointer hover:bg-gray-300"
                    onClick={() => setSelectedArticle(null)}
                >
                    <X className="text-gray-700 size-7"/>
                </div>       
                <div className="h-full overflow-auto z-[2005]">
                    <ImageAlbum imageUrls={imageUrls}/>
                    <div className="px-12 py-8">
                        <div className="flex mb-5 items-center">
                            <div className="flex gap-2">
                            {
                                article?.types.map(t => (
                                <div className="rounded-full bg-blue-100 px-3 py-[6px] text-sm text-[#033c46]">{ArticleTypeLabels[t.type]}</div>
                                ))
                            }       
                            <div className="flex ml-4 gap-2 items-center text-gray-400 text-sm">
                                <Calendar className="size-5 "/>
                                <p>{date.toLocaleDateString()}</p>
                            </div>  
                            </div>     
                            <div>

                            </div>
                            <div className="flex ml-auto items-center gap-3">
                                {article.sourceUrl &&
                                <Link className="rounded-full flex gap-1 items-center bg-[#032930] px-4 py-2 text-sm text-white" to={article.sourceUrl}>
                                     <ExternalLink className="size-4"/>
                                     <p></p>{article.sourceTitle}
                                </Link>
                                }
                                <button className="p-3 rounded-full border hover:bg-gray-200 border-gray-400 border-opacity-60">
                                    <Share2 className="size-4"/>
                                </button> 
                            </div>

                        </div>             
                        <h1 className="text-3xl font-[600] mb-3">{article.title}</h1>
                        <p className="whitespace-pre-line text-base font-normal leading-7">{article.text}</p>
                    </div>

                </div>
            </div>
        </div>
    )
    
}